import React, { Component} from 'react';
import { GoogleLogin } from 'react-google-login';

export default class GoogleAppLogin extends Component {
    handleResponse = (data) => {
        window.AvaCAS.loginSocial({ accessToken: data.accessToken, type: 'google'})
            .then(
                (data) => {
                    this.props.progressStopHandler();
                    this.props.redirectHandler(data);
                },
                (error) => {
                    console.error('Google logged wrong from API - there is no account with this Google id');
                    this.setState({
                        inProgress: false,
                        loginError: 'Google login data incorrect',
                    });
                }
            );
    };

    handleError = (error) => {
        this.setState({
            inProgress: false,
            loginError: 'Google login data incorrect',
        });
        this.props.progressStopHandler();
    };

    onRequest = () => {
        this.props.progressHandler();
    };

    render() {
        return (
            <GoogleLogin
                clientId={this.props.googleAppId}
                buttonText="LOGIN WITH GOOGLE"
                onSuccess={this.handleResponse}
                onFailure={this.handleError}
                onRequest={this.onRequest}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/GoogleAppLogin/GoogleAppLogin.js